import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class TaigaConfigService {
  constructor() { }

  /**
   * Xóa thuộc tính theme toàn cục của Taiga UI
   */
  removeAttributeGlobalStyle(): void {
    document.body.removeAttribute(
      'data-tui-theme',
    );
  }

}
